import OrderRentee from './OrderRentee'

export default OrderRentee
